import { toPunycode } from '../../utils/domainUtils';
import { PendingAiSummaryEntry } from './types';

export interface PendingSummaryMatchQuery {
  threatName: string;
  companyId?: number | null;
}

// Find the pending summary a "created" WebSocket event belongs to. Names are
// punycode-normalized on both sides so IDN domains match regardless of the
// form they were submitted in. Company is used only as a tiebreaker when the
// event carries one, so events without a company_id still resolve.
export function findMatchingPendingSummary(
  entries: PendingAiSummaryEntry[],
  query: PendingSummaryMatchQuery,
): PendingAiSummaryEntry | undefined {
  const wsName = toPunycode(query.threatName || '');
  if (!wsName) return undefined;
  return entries.find(entry => {
    if (toPunycode(entry.threatName) !== wsName) return false;
    if (query.companyId != null && entry.companyId != null) {
      return entry.companyId === query.companyId;
    }
    return true;
  });
}
